import React, { useState } from 'react';
import { SurveyQuestionOption, SurveyQuestionOptionVariant } from '@x-guard/xgac-types/xgac';
import { useLocale } from 'src/lib/hook';
import { SelectedOption } from 'src/components';
import Checkbox from './Checkbox';
import CheckboxTextInput from './CheckboxTextInput';
import Button from '../Button';
import styles from './style.module.scss';

interface FollowUpProps {

  options: SurveyQuestionOption[];
  selectedFollowUpOptions: SelectedOption[];
  onContinuePress: (selectedOptions: SelectedOption[]) => void;
}

const FollowUp: React.FC<FollowUpProps> = ({
  options, selectedFollowUpOptions, onContinuePress,
}) => {

  const maxValue = Math.max(...options.map((option) => option.value)) + 1;
  const { t } = useLocale();
  const [selectedOptions, setSelectedOptions] = useState<SelectedOption[]>(selectedFollowUpOptions);
  const [textInput, setTextInput] = useState(selectedOptions.find((response) => response.value === maxValue)?.label || '');

  const handleCheckboxChange = (option: SurveyQuestionOption) => {

    if (selectedOptions.some((response) => response.value === option.value)) {

      setSelectedOptions((prevSelectedOptions) => prevSelectedOptions
        .filter((response) => response.value !== option.value)
        .sort((a, b) => a.value - b.value));

    } else {

      setSelectedOptions((prevSelectedOptions) => {

        const newSelectedOptions = [...prevSelectedOptions, { value: option.value, label: option.label } as SelectedOption];
        newSelectedOptions.sort((a, b) => a.value - b.value);

        return newSelectedOptions;

      });

    }

  };

  const handleContinuePress = () => {

    if (selectedOptions.some((response) => response.value === maxValue)) {

      setSelectedOptions((prevSelectedOptions) => {

        const newOptions = prevSelectedOptions
          .map((response) => (response.value === maxValue ? { ...response, label: textInput } : response));
        newOptions.sort((a, b) => a.value - b.value);
        onContinuePress(newOptions);

        return newOptions;

      });

    } else {

      onContinuePress(selectedOptions);

    }

  };

  return (
    <div className = {styles['follow-up-container']}>
      <div className = {styles['scrollable-answers']}>
        {options.map((option) => (
          <div key={option.value}>
            <Checkbox
              checked={selectedOptions.some((response) => response.value === option.value)}
              onChange={() => handleCheckboxChange(option)}
              label={option.label}
            />

          </div>
        ))}
        <div className={styles['checkbox-input']} key={maxValue}>
          <CheckboxTextInput
            checked={selectedOptions.some((response) => response.value === maxValue)}
            onChange={ () => handleCheckboxChange(
              { value: maxValue, label: textInput, variant: SurveyQuestionOptionVariant.Primary },
            ) }
            setTextInput={setTextInput}
            textInput={textInput}
            maxValue={maxValue}
          />
        </div>
      </div>
      <Button text={`${t('component.answerType.button.continue')}`} disabled={selectedOptions.length === 0}
        color={'primary'} onClick={handleContinuePress} />
    </div>
  );

};

export default FollowUp;
